import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24 1C15.2 1 6.015 7.988 6 18c-.018 11.981 18 30 18 30s18.019-17.994 18-30c-.016-9.997-9.2-17-18-17zm0 25a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
    }, null, -1)
  ])))
}
export default { render: render }